"use client";

import { privacyData } from "@/data/footer-data";
import { useLocale } from "next-intl";
import React from "react";

export default function Privacy() {
  const locale = useLocale();
  const isAr = locale === "ar";

  return (
    <main
      dir={isAr ? "rtl" : "ltr"}
      className="min-h-screen bg-slate-50 text-brand-navy selection:bg-brand-red selection:text-white"
    >
      <div className="relative overflow-hidden bg-brand-navy pt-44 pb-32">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,var(--color-brand-red)_0%,transparent_25%)] opacity-20" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,var(--color-brand-blue)_0%,transparent_25%)] opacity-10" />

        <section className="container relative mx-auto px-6">
          <div className="max-w-4xl">
            <div className="flex items-center gap-4 mb-8">
              <span className="h-px w-12 bg-brand-red" />
              <span className="text-brand-creamy uppercase tracking-[0.3em] text-xs font-bold">
                {isAr ? "الجانب القانوني" : "Legal Department"}
              </span>
            </div>
            <h1 className="text-5xl md:text-8xl font-black text-white mb-8 tracking-tighter">
              {isAr ? "سياسة" : "PRIVACY"}{" "}
              <span className="text-transparent bg-clip-text bg-linear-to-r from-brand-red to-brand-blue">
                {isAr ? "الخصوصية" : "POLICY"}
              </span>
            </h1>
            <p className="text-white/60 text-lg md:text-2xl max-w-2xl leading-relaxed font-light">
              {isAr
                ? "في الدولية، نضع خصوصية عملائنا في مقدمة أولوياتنا. توضح هذه السياسة التزامنا بحماية بياناتك الصناعية والشخصية."
                : "At Al Dawlia, we prioritize our clients' privacy. This policy outlines our commitment to protecting your industrial and personal data."}
            </p>
          </div>
        </section>
      </div>

      <section className="container mx-auto px-6 -mt-16 relative z-10">
        <div className="grid gap-6 md:gap-8 max-w-6xl mx-auto">
          {privacyData.map((item, index) => (
            <article
              key={item.id}
              className="group bg-white p-8 md:p-12 rounded-3xl border border-slate-200 shadow-[0_2px_40px_-12px_rgba(0,0,0,0.08)] hover:shadow-[0_20px_50px_-12px_rgba(173,31,35,0.1)] transition-all duration-500 hover:-translate-y-1"
            >
              <div className="flex flex-col md:flex-row md:items-start gap-6 md:gap-10">
                <span className="flex-none flex items-center justify-center w-14 h-14 rounded-2xl bg-slate-50 text-brand-navy font-black text-xl border border-slate-100 group-hover:bg-brand-red group-hover:text-white group-hover:border-brand-red transition-all duration-500">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div className="space-y-4">
                  <h2 className="text-2xl md:text-3xl font-bold text-brand-navy group-hover:text-brand-blue transition-colors">
                    {isAr ? item.titleAr : item.titleEn}
                  </h2>
                  <p className="text-slate-500 leading-relaxed text-base md:text-xl font-normal max-w-4xl">
                    {isAr ? item.contentAr : item.contentEn}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-24 pb-20 text-center">
          <div className="inline-flex flex-col items-center">
            <p className="text-slate-400 mb-6 font-medium">
              {isAr ? "هل لديك استفسارات إضافية؟" : "Have more questions?"}
            </p>
            <a
              href="mailto:legal@aldawlia.com"
              className="group relative px-8 py-4 bg-brand-navy rounded-2xl overflow-hidden transition-all hover:scale-105 active:scale-95"
            >
              <div className="absolute inset-0 bg-linear-to-r from-brand-red to-brand-blue opacity-0 group-hover:opacity-100 transition-opacity" />
              <span className="relative z-10 text-white font-bold tracking-tight">
                legal@aldawlia.com
              </span>
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
